module.exports = __webpack_public_path__ + "img/updated_keyboard.dc5a899b.png";